import QuestionHeader from "../component/QuestionHeader";
import QuestionFooter from "../component/QuestionFooter";
import {useEffect, useState} from "react";
import {wait} from "@testing-library/user-event/dist/utils";
import {useQuestion} from "../../../../redux/Reducers/QuestionReducer";
import {useParams} from "react-router-dom";
import GenericQuestionModal from "../Modal/GenericQuestionModal/GenricQuestionModal";
import useForm from "../../../../hooks/useForm";
import AnswerDropDown from "../component/AnswerDropDown";
import FormNoneFieldErrors from "../../../../components/Form/FormNoneFieldErrors";
import URLS from "../../../../API/Axios/URLS";

function calculateScore(text, transcript, answer) {
    let transcriptArray = transcript.split("")
    let textArray = text.split("")
    let answerArray = answer.split("")
    let score = 0
    let total = 0
    let arr = []
    for (let i = 0; i < textArray.length; i++) {
        if (textArray[i] === "_") {
            if (transcriptArray[i] === answerArray[i]) {
                score += 1
                arr.push({
                    letter: transcriptArray[i],
                    correct: true
                })
            } else {
                arr.push({
                    letter: transcriptArray[i],
                    correct: false
                })
            }
            total += 1
        }
    }
    let percentage = ((score / total) * 100)
    percentage = percentage.toFixed(0)


    return {
        score: `${score} / ${total}`,
        percentage,
        arr
    }
}

function MapQuestion({question, answer, setAnswer, showAnswer, transcript}) {

    let mt = 'mt-1'
    if (showAnswer) mt = 'mt-5'
    let transcriptArray = transcript?.split(" ")
    let answerArray = answer?.split(" ")
    return question?.split(" ")?.map((word, wordIndex) => {
            if (word?.includes("_")) {
                let wordArray = word.split("")
                let transcriptWord = transcriptArray[wordIndex]
                let answerWord = answerArray[wordIndex]
                // getElementById

                return <div className={"flex text-xl "}>{wordArray?.map((letter, index) => {
                        let word = document?.getElementById("word-" + wordIndex)?.value()

                        if (letter === "_") {
                            return <div className={`items-center  gap-0 flex justify-center text-center flex-col
                    ${!showAnswer && mt}
                    `}>
                                {showAnswer && <div
                                    className={`relative text-sm
                            ${answerWord[index] === transcriptWord[index] ? "text-green-600" : "text-red-600"}
                            `}
                                    key={`letter-${index}`}>{transcriptWord[index]} </div>}
                                <input maxLength={1} className={`border  answerInput border-gray-500 w-8 text-center
                        ${showAnswer ? !answerWord[index]?.includes("?") ? answerWord[index] === transcriptWord[index] ? "text-white bg-green-600" : "text-white bg-red-600" : "" : ""}
                        `} type={"text"}
                                       onKeyDown={(e) => {
                                           if (e.key !== "Backspace")
                                               return;
                                           let MyValue = e.target.value
                                             if (MyValue !== "") {
                                                 e.target.value = ""
                                                 return;
                                             }

                                           // e.key ranges from A-Z and a-z

                                           let currentInput = e.target;
                                           let inputs = Array.from(document.querySelectorAll('.answerInput'));

                                           let currentIndex = inputs.indexOf(currentInput);
                                           let prevInput = inputs[currentIndex - 1];
                                           let value = prevInput?.value
                                           if (prevInput) {
                                               prevInput.focus();
                                           }

                                           //     if key is from a-z or A-Z and not any other like backspace or enter


                                       }}
                                       onFocus={(e) => {
                                           //     clear input if it is not empty
                                           // if (e.target.value !== "") {
                                           //     e.target.value = ""
                                           // }
                                       }}
                                       onChange={(e) => {
                                           const newLetter = e.target.value;

                                           let answerArray = answer?.split(" ");
                                           if (answerArray?.length !== 0) {
                                               wait(10).then(() => {
                                                   let wordArray = answerArray[wordIndex].split("");
                                                   wordArray[index] = newLetter;
                                                   answerArray[wordIndex] = wordArray.join("");
                                                   let newAnswer = answerArray.join(" ");
                                                   setAnswer(newAnswer)
                                                   if (newLetter !== "") {
                                                       let currentInput = e.target;

                                                       let inputs = Array.from(document.querySelectorAll('.answerInput'));
                                                       let currentIndex = inputs.indexOf(currentInput);
                                                       let nextInput = inputs[currentIndex + 1];
                                                       let value = nextInput?.value
                                                       if (value === "" || value === undefined) {
                                                           if (nextInput) {
                                                               nextInput.focus();
                                                           }
                                                       }

                                                   }

                                               })
                                           } else {
                                               let wordArray = answerArray[wordIndex].split("");
                                               wordArray[index] = newLetter;
                                               answerArray[wordIndex] = wordArray.join("");
                                               let newAnswer = answerArray.join(" ");
                                               setAnswer(newAnswer)
                                               //     click tab
                                               if (newLetter !== "") {
                                                   let currentInput = e.target;
                                                   let inputs = Array.from(document.querySelectorAll('.answerInput'));
                                                   let currentIndex = inputs.indexOf(currentInput);
                                                   let nextInput = inputs[currentIndex + 1];
                                                   let value = nextInput?.value
                                                   if (value === "" || value === undefined) {
                                                       if (nextInput) {
                                                           nextInput.focus();
                                                       }
                                                   }
                                               }

                                           }
                                       }
                                       }/>
                            </div>
                        } else if (letter !== "," && letter !== "." && letter !== "?" && letter !== "!" && letter !== "’" && letter !== "‘" && letter !== "“" && letter !== "”") {
                            return <input disabled className={`border ${mt} border-gray-500 w-8 text-center`} type={"text"}
                                          value={letter}
                            />
                        } else {
                            return <span className={mt} key={index}>{letter} </span>
                        }
                    }
                )}</div>
            } else {
                return <span className={mt + " text-xl"} key={wordIndex}>{word} </span>
            }
        }
    )
}

export default function FillInTheBlank({className, ...props}) {
    const [dataLoaded, setDataLoaded] = useState(false)
    const {id} = useParams()
    const [response, setResponse] = useState(null)
    const {question, questionActions, isLoading} = useQuestion()
    const [showModal, setShowModal] = useState(false)
    const [form, error, loading, setFormData, actions] = useForm({
        questionId: id,
        answer: [],
    })
    useEffect(
        () => {

            questionActions.loadQuestions(id)
            if (!isLoading) {
                setDataLoaded(true)
                console.log(question)
            }
        }, []
    )


    useEffect(() => {
        if (question?.text) {
            setFormData({
                answer: question?.text?.replaceAll("_", "?")
            })
        }
    }, [isLoading]);

    function submitAnswer() {
        if (form?.answer.length === 0) {
            actions.setError({
                non_field_errors: ["Please select at least one option"]
            })
            return
        }
        actions.post(URLS.genericQuestionView).then(response => {
            setResponse(response?.data)

        })


    }


    return (
        <div className={`rounded-lg shadow-lg p-4 ${className}`}>
            <QuestionHeader  {...question}
                             timeLimit={question?.timeLimit && question?.timeLimit +5000}

            />
            <GenericQuestionModal
                result={response}
                showModal={showModal} setShowModal={setShowModal}/>
            <div className={" flex flex-col items-center md:flex-row p-2 py-8 justify-center gap-8"}>
                <div className={"flex flex-1 px-8 flex-col gap-4"}>

                    <div className={`text-lg font-semibold gap-2 flex items-center flex-wrap
                    ${!!response ? "cursor-not-allowed pointer-events-none" : ""}
                    `}>
                        {
                            dataLoaded && form?.answer?.split &&

                            <MapQuestion
                                question={question?.text}
                                showAnswer={!!response}
                                transcript={question?.transcript}
                                setAnswer={(ans) => {
                                    console.log(ans)
                                    setFormData({
                                        answer: ans
                                    })
                                }}
                                answer={form?.answer}
                            />
                        }
                    </div>

                    <FormNoneFieldErrors className={"mt-3"}
                                         errors={error?.answer || error?.non_field_errors || error?.time}/>


                </div>


            </div>
            <QuestionFooter

                loading={loading}
                disabled={response}
                onClickSubmit={submitAnswer}
                className={"mx-4 my-2"}/>

            <AnswerDropDown
                headerTitle={"Answer"}
                justifications={
                    question?.correct?.join(", ")
                }
            />


        </div>

    )
}
